import kebabCase from 'lodash/kebabCase';
import upperFirst from 'lodash/upperFirst';
import map from 'lodash/map';
import startCase from 'lodash/startCase';
import toUpper from 'lodash/toUpper';
import type { AddressComponents } from '../../interfaces/addressComponents';

function upperFirstEveryWord(stringToUppercase: string) {
  const words = stringToUppercase.split(' ');
  return map(words, upperFirst).join(' ');
}

const propertyUtils = {
  formatAddress(addressComponents: AddressComponents) {
    const { street, city, state, unit, name, zip } = addressComponents;

    // Transformations
    let formattedStreet = street ? upperFirstEveryWord(street) : '';
    const formattedCity = city ? startCase(city) : '';
    const formattedState = state ? toUpper(state) : '';
    const formattedUnit = unit ? toUpper(unit) : '';
    const formattedName = name ? upperFirstEveryWord(name) : '';

    if (unit && unit.length) {
      formattedStreet += ` ${formattedUnit}`;
    }

    const formattedAddress = [formattedStreet, formattedCity, formattedState].filter((val) => val).join(', ');
    const formattedCityState = [formattedCity, formattedState].filter((val) => val).join(', ');
    const formattedCityStateZip = `${formattedCityState} ${zip}`;
    const formattedCompleteAddress = [`${formattedStreet},`, formattedCityState, zip].filter((val) => val).join(' ');
    const formattedKebobCase = kebabCase(formattedCompleteAddress);

    return {
      formattedAddress,
      formattedCityState,
      formattedCityStateZip,
      formattedCompleteAddress,
      formattedName,
      formattedStreet,
      formattedKebobCase,
    };
  },
};

export default propertyUtils;
